import { schema } from 'normalizr'
import { workerSchema } from '@/schema/worker'

export const scheduleCommentSchema = new schema.Entity('scheduleComments', {
  worker: workerSchema
})
